import ProjectSettingsPage from '@/modules/project/pages/ProjectSettingsPage'
import ProjectFeaturesPage from '@/modules/project/pages/ProjectFeaturesPage'

export default [
  {
    name: 'ProjectCreate',
    path: '/account/project/create',
    component: ProjectSettingsPage,
    meta: {
      auth: ['createProject'],
      title: 'ProjectSettings_CreateTitle',
      project: false
    }
  },
  {
    name: 'ProjectSettings',
    path: '/account/project/settings',
    component: ProjectSettingsPage,
    meta: {
      auth: ['updateProject', 'viewProject'],
      title: 'ProjectSettings_Title'
    }
  },
  {
    name: 'ProjectFeatures',
    path: '/account/project/features',
    component: ProjectFeaturesPage,
    meta: {
      auth: ['ProjectFeatureFlags::Read'],
      title: 'ProjectFeatures_Title'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/project/router/index.js